module.exports = __webpack_public_path__ + "img/tc-55x60.6f114750.jpg";